/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicFilterDomainConditionDto } from './PublicFilterDomainConditionDto';

export type PublicSourceFilterDomainConditionDto = (PublicFilterDomainConditionDto & {
    /**
     * Operator of the condition
     */
    operator?: PublicSourceFilterDomainConditionDto.operator;
    /**
     * List of the sources in the condition in URI format. <a href="https://docs.siffletdata.com/docs/uri">[Read more about URIs]</a>
     */
    sources?: Array<string>;
} & {
    /**
     * Operator of the condition
     */
    operator: PublicSourceFilterDomainConditionDto.operator;
    /**
     * List of the sources in the condition in URI format. <a href="https://docs.siffletdata.com/docs/uri">[Read more about URIs]</a>
     */
    sources: Array<string>;
});

export namespace PublicSourceFilterDomainConditionDto {

    /**
     * Operator of the condition
     */
    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
